module.exports = __webpack_public_path__ + "img/hero04.b9c6caca.jpg";